module.exports = __webpack_public_path__ + "static/img/logo-cme.5be4267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new/logo-cme.png
// module id = /QTG
// module chunks = 2